import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';
import { ServiceProviderService } from '../../Service/Service-providers/service-provider.service';
import { FormStateService } from './add-sp-new-component/form-state.service';

@Component({
  selector: 'formly-field-multi-file',
  template: `
    <div class="custom-file-upload ">
      <label
        for="file-upload"
        class="upload-label"
        [class.disabled]="selectedFiles.length >= 5"
      >
        <div class="flex justify-content-between flex-wrap">
          <div class="flex align-items-center justify-content-center mr-3">          
            <i class="pi pi-cloud-upload"></i>
          </div>
          <div class="flex align-items-center justify-content-center">{{ to.placeholder }}</div>
        </div>
      </label>
      <input 
        id="file-upload" 
        #fileInput
        type="file" 
        (change)="onFileSelect($event)" 
        [disabled]="selectedFiles.length >= 5" 
        multiple 
        [accept]="getAcceptedFileTypes()"
      />
    </div>
    <div *ngIf="selectedFiles.length > 0" class="file-list">
      <div *ngFor="let file of selectedFiles; let i = index" class="file-item">
        <div class="file-info">
          <div class="file-icon">
            <i class="pi pi-file-pdf" *ngIf="isPdfFile(file)" style="color: #FFA500"></i>
            <i class="pi pi-image" *ngIf="isImageFile(file)" style="color: #4285F4"></i>
          </div>
          <div class="file-details">
            <span 
              (click)="previewFile(file)" 
              class="file-name" 
              [class.hovered]="hoverIndex === i"
              (mouseover)="hoverIndex = i" 
              (mouseout)="hoverIndex = -1"
            >{{ file.name }}</span>
            <span class="file-size">{{ getFileSize(file.size) }}</span>
          </div>
          
        </div>
        <!-- <div class="progress-bar">
          <div class="progress-fill" [style.width.%]="100"></div>
        </div> -->
        <!-- <button type="button" (click)="removeFile(i)" class="remove-button">Remove</button> -->
        <i class="pi pi-trash remove-button" (click)="removeFile(i)"></i>
      </div>
    </div>

    <div *ngIf="showError" class="error-message">
    {{  getErrorMessage() }}
    </div>
    <p-dialog header="Image Preview" [(visible)]="previewVisible" [modal]="true" [closable]="true" (onHide)="closePreview()" [style]="{width: '600px'}">
      <img *ngIf="isImageFile()" [src]="previewSrc" alt="Image Preview" class="modal-image" />
      <a *ngIf="isPdfFile()" [href]="previewSrc" target="_blank" class="pdf-preview">
       View PDF
      </a>

    </p-dialog>
  `,
  styles: [`
    .custom-file-upload {
      display: inline-block;
      position: relative;
    }
    .error-message {
       color: #e24c4c;
       font-size: 13px;
       margin-top: 2px;
    }
    .upload-label {
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: white;
      border: 1px solid #d0d5dd;
      border-radius: 8px;
      padding: 10px 20px;
      font-size: 14px;
      font-weight: 600;
      color: #344054;
      cursor: pointer;
      transition: background-color 0.3s ease, border-color 0.3s ease;
    }

    .upload-label.disabled {
      cursor: not-allowed;
      opacity: 0.6;
    }

    .upload-label:hover:not(.disabled) {
      background-color: #f3f4f6;
      border-color: #9ca3af;
    }

    input[type="file"] {
      display: none;
    }

    .file-list {
      margin-top: 10px;
      // border: 1px solid #d0d5dd;
      // border-radius: 4px;

    }

    .file-item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      background-color: #f9fafb;
      border: 1px solid #d0d5dd;
      border-radius: 4px;
      padding: 8px 12px;
      margin-bottom: 6px;
    }

    .file-name {
      color: #344054;
      cursor: pointer;
      flex-grow: 1;
      transition: font-weight 0.3s ease, text-decoration 0.3s ease;
    }

    .file-name.hovered {
      font-weight: bold;
      text-decoration: underline;
    }

    .remove-button {
      background: none;
      border: none;
      color: red;
      cursor: pointer;
    }

    .modal-image {
      max-width: 100%;
      max-height: 60vh;
      display: block;
      margin: 0 auto;
    }

    .file-info {
      display: flex;
      align-items: center;
    }
    .file-icon {
      font-size: 24px;
      margin-right: 10px;
    }

    .file-details {
      display: flex;
      flex-direction: column;
    }
    .file-size {
      font-size: 12px;
      color: #6b7280;
    }

    .progress-bar {
      width: 100%;
      height: 6px;
      background: #f3f4f6;
      border-radius: 3px;
      margin-top: 5px;
      margin-bottom: 8px;
    }

    .progress-fill {
      height: 100%;
      width: 80%;
      background: #f97316;
      border-radius: 3px;
      transition: width 0.5s;
    }
  `]
})
export class FormlyFieldMultiFile extends FieldType<FieldTypeConfig> implements OnInit {
  selectedFiles: File[] = [];
  previewSrc: string | null = null;
  hoverIndex: number = -1; // Track hover index
  previewVisible: boolean = false; // Control the visibility of the PrimeNG Dialog
  uploadProgress: number[] = [];
  @ViewChild('fileInput') fileInput!: ElementRef<HTMLInputElement>;

  constructor(
    private api: ServiceProviderService,
    private cdr: ChangeDetectorRef,
    private fileService: FormStateService
  ) {
    super();
  }

  ngOnInit() {
    console.log('FormlyFieldMultiFile initialized');
    this.selectedFiles = this.fileService.getSelectedFiles() || [];
    if (this.formControl.value && Array.isArray(this.formControl.value)) {
      this.formControl.value.forEach((fileId: any) => {

        // Check for duplicate file by ID
        const alreadyExists = this.selectedFiles.some((file: any) => file.id === fileId);
        if (!alreadyExists) {
          this.api.getFileById(fileId).subscribe((file: any) => {

            // Check if a file with the same name already exists
            const fileObj = new File([file.content], file.fileName);
            if (!this.selectedFiles.some(f => f.name === file.fileName)) {
              this.selectedFiles.push(fileObj);
              this.fileService.setSelectedFiles(this.selectedFiles);
              this.cdr.detectChanges();
            } else {
              console.log(`File ${file.fileName} already exists in selectedFiles.`);
            }
          });
        } else {
          console.log(`File with ID ${fileId} already exists. Skipping.`);
        }
      });
    }
  }


  onFileSelect(event: any) {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      const newFiles = Array.from(input.files);

      // Ensure the total number of files does not exceed 5
      if (this.selectedFiles.length + newFiles.length > 5) {
        alert('You can only select up to 5 files.');
        return;
      }

      newFiles.forEach(file => {
        // Check for duplicates based on file name and lastModified attributes
        const alreadyExists = this.selectedFiles.some(f => f.name === file.name && f.lastModified === file.lastModified);
        if (!alreadyExists) {
          console.log('New file selected:', file);
          this.selectedFiles.push(file);


          const formData = new FormData();
          formData.append('file', file);
          formData.append('description', 'File upload description');
          //formData.append('fileSourceId', '1');
          const fileSourceId = this.to['fileSourceId'];
          if (!fileSourceId) {
            console.error('fileSourceId is undefined');
            return;
          }
          formData.append('FileSourceId', fileSourceId.toString());

          this.api.createFiles(formData).subscribe((res: any) => {
            const currentValues = this.formControl.value || [];
            this.formControl.setValue([...currentValues, res.fileId]);
            console.log('File uploaded. Received fileId:', res.fileId);
            this.cdr.detectChanges();
          });
        } else {
          console.log(`File ${file.name} already exists. Skipping.`);
        }
      });

      this.fileService.setSelectedFiles(this.selectedFiles);
    }
  }
  removeFile(index: number) {
    const fileToRemove = this.selectedFiles[index];
    const fileIdToRemove = this.formControl.value[index];

    if (fileIdToRemove) {
      this.api.deleteFile(fileIdToRemove).subscribe(
        (res: any) => {
          if (res.isSuccess) {
            console.log(`File ID ${fileIdToRemove} deleted: ${res.result}`);
          } else {
            console.error(`Failed to delete File ID ${fileIdToRemove}:`, res.errors);
          }
        },
        (error) => {
          console.error(`Error deleting File ID ${fileIdToRemove}:`, error);
        }
      );
    }

    this.selectedFiles.splice(index, 1);
    this.fileService.setSelectedFiles(this.selectedFiles);

    const updatedFileIds = this.formControl.value.filter((_: any, i: number) => i !== index);
    console.log('Updated file IDs after removal:', updatedFileIds);

    this.formControl.setValue(updatedFileIds);
    this.cdr.detectChanges();

    if (this.fileInput && this.fileInput.nativeElement) {
    this.fileInput.nativeElement.value = '';
  }
  }


  previewFile(file: File) {
    const reader = new FileReader();
    if (this.isPdfFile(file)) {
      reader.onload = () => {
        const blob = new Blob([reader.result as ArrayBuffer], { type: 'application/pdf' });
        const url = window.URL.createObjectURL(blob);
        window.open(url, '_blank'); // This opens the PDF in a new tab
        window.URL.revokeObjectURL(url); // Clean up the URL object after use
      };
      reader.readAsArrayBuffer(file);
    } else if (this.isImageFile(file)) {
      reader.onload = () => {
        this.previewSrc = reader.result as string;
        this.previewVisible = true; // Show the dialog
        this.cdr.detectChanges(); // Trigger change detection to update the UI
      };
      reader.readAsDataURL(file);
    }
  }

  closePreview() {
    this.previewVisible = false;
    this.previewSrc = null;
  }

  clearFileSelection() {
    console.log('Clearing all selected files');

    if (this.formControl.value && Array.isArray(this.formControl.value)) {
      const fileIds = [...this.formControl.value]; // Copy file IDs

      fileIds.forEach((fileId) => {
        this.api.deleteFile(fileId).subscribe(
          (res: any) => {
            if (res.isSuccess) {
              console.log(`File ID ${fileId} deleted: ${res.result}`);
            } else {
              console.error(`Failed to delete File ID ${fileId}:`, res.errors);
            }
          },
          (error) => {
            console.error(`Error deleting File ID ${fileId}:`, error);
          }
        );
      });
    }

    // Reset UI and form control after deletion
    this.selectedFiles = [];
    this.fileService.setSelectedFiles([]);
    this.formControl.setValue([]);
    this.cdr.detectChanges();
  }

  getFileSize(size: number): string {
    if (size < 1024) return size + ' B';
    else if (size < 1024 * 1024) return (size / 1024).toFixed(1) + ' KB';
    else return (size / (1024 * 1024)).toFixed(1) + ' MB';
  }

  isImageFile(file: File = this.selectedFiles[0]): boolean {
    return file ? file.type.startsWith('image/') : false;
  }

  isPdfFile(file: File = this.selectedFiles[0]): boolean {
    return file ? file.type === 'application/pdf' : false;
  }

  getAcceptedFileTypes(): string {
    const fileSourceId = this.to['fileSourceId'];
    if (fileSourceId === 7 || fileSourceId === 10) {
      return '.pdf,.png,.jpg,.jpeg';
    } else {
      return 'image/png, image/jpeg';
    }
  }
  getErrorMessage(): string {
    const errors = this.field.formControl?.errors;

    if (errors && errors['required']) {
      return 'Please select an image';
    }

    return 'Invalid file upload.';
  }


}
